// import React, { useEffect, useState } from "react";

// const Notes = () => {
//   const [notes, setNotes] = useState([]);
//   const [title, setTitle] = useState("");
//   const [content, setContent] = useState("");
//   const [editingId, setEditingId] = useState(null);

//   useEffect(() => {
//     loadNotes();
//   }, []);

//   const loadNotes = async () => {
//     const res = await fetch("http://localhost/erp/notes/list.php");
//     const data = await res.json();
//     setNotes(data.notes || []);
//   };

//   const submitNote = async () => {
//     if (!title || !content) return alert("Fill all fields");

//     const url = editingId
//       ? "http://localhost/erp/notes/update.php"
//       : "http://localhost/erp/notes/create.php";

//     await fetch(url, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         id: editingId,
//         title,
//         content,
//       }),
//     });

//     resetForm();
//     loadNotes();
//   };

//   const editNote = (note) => {
//     setTitle(note.title);
//     setContent(note.content);
//     setEditingId(note.id);
//   };

//   const deleteNote = async (id) => {
//     if (!window.confirm("Delete this note?")) return;

//     await fetch("http://localhost/erp/notes/delete.php", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ id }),
//     });

//     loadNotes();
//   };

//   const resetForm = () => {
//     setTitle("");
//     setContent("");
//     setEditingId(null);
//   };

//   const formatDate = (dateStr) => {
//     const d = new Date(dateStr);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-8">
//       <div className="max-w-4xl mx-auto space-y-6">
//         <h1 className="text-2xl font-extrabold text-gray-900">Notes</h1>

//         {/* FORM */}
//         <div className="bg-white p-5 rounded-xl shadow border space-y-3">
//           <input
//             placeholder="Title"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//             className="w-full border px-3 py-2 rounded text-sm"
//           />

//           <textarea
//             placeholder="Write your note..."
//             rows="4"
//             value={content}
//             onChange={(e) => setContent(e.target.value)}
//             className="w-full border px-3 py-2 rounded text-sm"
//           />

//           <div className="flex gap-3 justify-end">
//             {editingId && (
//               <button
//                 onClick={resetForm}
//                 className="px-4 py-2 border rounded text-sm font-semibold"
//               >
//                 Cancel
//               </button>
//             )}
//             <button
//               onClick={submitNote}
//               className="bg-indigo-600 text-white px-5 py-2 rounded font-bold text-sm"
//             >
//               {editingId ? "Update Note" : "Add Note"}
//             </button>
//           </div>
//         </div>

//         {/* NOTES LIST */}
//         <div className="space-y-4">
//           {notes.map((note) => (
//             <div
//               key={note.id}
//               className={`bg-white p-4 rounded-xl shadow border transition
//                 ${
//                   editingId === note.id
//                     ? "border-amber-400 bg-amber-50"
//                     : "hover:shadow-md"
//                 }
//               `}
//             >
//               <div className="flex items-center justify-between">
//                 <h3 className="font-bold text-lg text-gray-900">
//                   {note.title}
//                 </h3>
//                 <span className="text-xs text-gray-400">
//                   {formatDate(note.created_at)}
//                 </span>
//               </div>

//               <p className="text-gray-600 text-sm mt-2 whitespace-pre-line">
//                 {note.content}
//               </p>

//               <div className="flex gap-3 mt-4">
//                 <button
//                   onClick={() => editNote(note)}
//                   className="px-3 py-1 text-xs font-bold rounded-full
//                              bg-amber-100 text-amber-700 hover:bg-amber-200"
//                 >
//                   ✏️ Edit
//                 </button>

//                 <button
//                   onClick={() => deleteNote(note.id)}
//                   className="px-3 py-1 text-xs font-bold rounded-full
//                              bg-red-100 text-red-700 hover:bg-red-200"
//                 >
//                   🗑 Delete
//                 </button>
//               </div>
//             </div>
//           ))}

//           {notes.length === 0 && (
//             <p className="text-center text-gray-400">No notes yet</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Notes;


// import React, { useEffect, useState } from "react";
// import { Api } from "../Api/Api";

// const Notes = () => {
//   const user = JSON.parse(localStorage.getItem("currentUser"));

//   const [notes, setNotes] = useState([]);
//   const [title, setTitle] = useState("");
//   const [content, setContent] = useState("");
//   const [editingId, setEditingId] = useState(null);

//   useEffect(() => {
//     if (!user?.userId) {
//       alert("User not logged in");
//       return;
//     }
//     loadNotes();
//   }, []);

//   const loadNotes = async () => {

//     const res = await fetch(`${Api}notes/list.php`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         user_id: user.userId,
//       }),
//     });

//     const data = await res.json();
//     setNotes(data.notes || []);
//   };

//   const submitNote = async () => {
//     if (!title || !content) {
//       alert("Fill all fields");
//       return;
//     }

//     const url = editingId ? `${Api}notes/update.php` : `${Api}notes/create.php`;


//     const payload = {
//       id: editingId,
//       title,
//       content,
//       user_id: user.userId,
//     };

//     console.log("Sending:", payload);

//     const res = await fetch(url, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     const data = await res.json();
//     console.log("Response:", data);

//     if (!data.status) {
//       alert("Failed to save note");
//       return;
//     }

//     resetForm();
//     loadNotes();
//   };

//   const editNote = (note) => {
//     setTitle(note.title);
//     setContent(note.content);
//     setEditingId(note.id);
//   };

//   const deleteNote = async (id) => {
//     if (!window.confirm("Delete this note?")) return;

  
//     await fetch(`${Api}notes/delete.php`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         id,
//         user_id: user.userId,
//       }),
//     });

//     loadNotes();
//   };

//   const resetForm = () => {
//     setTitle("");
//     setContent("");
//     setEditingId(null);
//   };


//  const formatDateTime = (dateStr) => {
//    if (!dateStr) return "";

//    // 🔧 Force ISO format
//    const fixed = dateStr.replace(" ", "T");
//    const d = new Date(fixed);

//    if (isNaN(d)) return "";

//    return d.toLocaleString("en-IN", {
//      day: "2-digit",
//      month: "short",
//      year: "numeric",
//      hour: "2-digit",
//      minute: "2-digit",
//      hour12: true,
//    });
//  };



//   return (
//     <div className="min-h-screen bg-gray-50 p-8">
//       <div className="max-w-4xl mx-auto space-y-6">
//         <h1 className="text-2xl font-extrabold">My Notes</h1>

//         {/* FORM */}
//         <div className="bg-white p-5 rounded-xl shadow border space-y-3">
//           <input
//             placeholder="Title"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//             className="w-full border px-3 py-2 rounded text-sm"
//           />

//           <textarea
//             placeholder="Write your note..."
//             rows="4"
//             value={content}
//             onChange={(e) => setContent(e.target.value)}
//             className="w-full border px-3 py-2 rounded text-sm"
//           />

//           <div className="flex justify-end gap-3">
//             {editingId && (
//               <button
//                 onClick={resetForm}
//                 className="px-4 py-2 border rounded text-sm font-semibold"
//               >
//                 Cancel
//               </button>
//             )}
//             <button
//               onClick={submitNote}
//               className="bg-indigo-600 text-white px-5 py-2 rounded font-bold text-sm"
//             >
//               {editingId ? "Update Note" : "Add Note"}
//             </button>
//           </div>
//         </div>

//         {/* LIST */}
//         <div className="space-y-4">
//           {notes.map((note) => (
//             // <div key={note.id} className="bg-white p-4 rounded shadow border">
//             //   <h3 className="font-bold">{note.title}</h3>
//             //   <p className="text-sm text-gray-600 mt-1">{note.content}</p>

//             //   <span className="text-xs text-gray-400">
//             //     {formatDateTime(note.created_at)}
//             //   </span>

//             //   <div className="flex gap-3 mt-4">
//             //     <button
//             //       onClick={() => editNote(note)}
//             //       className="flex items-center gap-1 px-3 py-1.5 text-xs font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded-lg transition-colors hover:bg-amber-100 active:bg-amber-200"
//             //     >
//             //       <span>✏️</span> Edit
//             //     </button>
//             //     <button
//             //       onClick={() => deleteNote(note.id)}
//             //       className="flex items-center gap-1 px-3 py-1.5 text-xs font-semibold text-red-700 bg-red-50 border border-red-200 rounded-lg transition-colors hover:bg-red-100 active:bg-red-200"
//             //     >
//             //       <span>🗑</span> Delete
//             //     </button>
//             //   </div>
//             // </div>
//             <div key={note.id} className="bg-white p-4 rounded shadow border">
//   <div className="flex justify-between items-start">
//     <h3 className="font-bold">{note.title}</h3>

//     <span className="text-xs text-black">
//       {formatDateTime(note.created_at)}
//     </span>
//   </div>

//   <p className="text-sm text-gray-600 mt-1">{note.content}</p>

//   <div className="flex gap-3 mt-4">
//     <button
//       onClick={() => editNote(note)}
//       className="px-3 py-1.5 text-xs font-semibold text-amber-700 bg-amber-50 border rounded-lg"
//     >
//       ✏️ Edit
//     </button>

//     <button
//       onClick={() => deleteNote(note.id)}
//       className="px-3 py-1.5 text-xs font-semibold text-red-700 bg-red-50 border rounded-lg"
//     >
//       🗑 Delete
//     </button>
//   </div>
// </div>

//           ))}

//           {notes.length === 0 && (
//             <p className="text-center text-gray-400">No notes yet</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Notes;


import React, { useEffect, useState } from "react";
import { Api } from "../Api/Api";

const Notes = () => {
  const user = JSON.parse(localStorage.getItem("currentUser"));

  const [notes, setNotes] = useState([]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user?.userId) {
      alert("User not logged in");
      return;
    }
    loadNotes();
  }, []);

  /* ================= LOAD NOTES ================= */
  const loadNotes = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${Api}notes/list.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: user.userId }),
      });

      const data = await res.json();

      if (data?.notes && Array.isArray(data.notes)) {
        setNotes(data.notes);
      } else {
        setNotes([]);
      }
    } catch (err) {
      console.error("Load notes error:", err);
      setNotes([]);
    } finally {
      setLoading(false);
    }
  };

  /* ================= SAVE NOTE ================= */
  const submitNote = async () => {
    if (!title.trim() || !content.trim()) {
      alert("Fill all fields");
      return;
    }

    const url = editingId ? `${Api}notes/update.php` : `${Api}notes/create.php`;

    const payload = {
      id: editingId,
      title,
      content,
      user_id: user.userId,
    };

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!data?.status) {
        alert("Failed to save note");
        return;
      }

      resetForm();

      // 🔥 IMPORTANT: wait until notes reload
      await loadNotes();
    } catch (err) {
      console.error("Save error:", err);
      alert("Server error");
    }
  };

  /* ================= ACTIONS ================= */
  const editNote = (note) => {
    setTitle(note.title);
    setContent(note.content);
    setEditingId(note.id);
  };

  const deleteNote = async (id) => {
    if (!window.confirm("Delete this note?")) return;

    await fetch(`${Api}notes/delete.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, user_id: user.userId }),
    });

    await loadNotes();
  };

  const resetForm = () => {
    setTitle("");
    setContent("");
    setEditingId(null);
  };

  /* ================= DATE FORMAT ================= */
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "";

    // Fix MySQL format → ISO
    const d = new Date(dateStr.replace(" ", "T"));
    if (isNaN(d)) return "";

    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto space-y-6">
        <h1 className="text-2xl font-extrabold">My Notes</h1>

        {/* FORM */}
        <div className="bg-white p-5 rounded-xl shadow border space-y-3">
          <input
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border px-3 py-2 rounded text-sm"
          />

          <textarea
            placeholder="Write your note..."
            rows="4"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="w-full border px-3 py-2 rounded text-sm"
          />

          <div className="flex justify-end gap-3">
            {editingId && (
              <button
                onClick={resetForm}
                className="px-4 py-2 border rounded text-sm font-semibold"
              >
                Cancel
              </button>
            )}
            <button
              onClick={submitNote}
              className="bg-indigo-600 text-white px-5 py-2 rounded font-bold text-sm"
            >
              {editingId ? "Update Note" : "Add Note"}
            </button>
          </div>
        </div>

        {/* LIST */}
        {loading && (
          <p className="text-center text-gray-400">Loading notes...</p>
        )}

        <div className="space-y-4">
          {notes.map((note) => (
            <div key={note.id} className="bg-white p-4 rounded shadow border">
              <div className="flex justify-between items-start">
                <h3 className="font-bold">{note.title}</h3>
                <span className="text-xs text-gray-500">
                  {formatDateTime(note.created_at)}
                </span>
              </div>

              <p className="text-sm text-gray-600 mt-1">{note.content}</p>

              <div className="flex gap-3 mt-4">
                <button
                  onClick={() => editNote(note)}
                  className="px-3 py-1.5 text-xs font-semibold text-amber-700 bg-amber-50 border rounded-lg"
                >
                  ✏️ Edit
                </button>

                <button
                  onClick={() => deleteNote(note.id)}
                  className="px-3 py-1.5 text-xs font-semibold text-red-700 bg-red-50 border rounded-lg"
                >
                  🗑 Delete
                </button>
              </div>
            </div>
          ))}

          {!loading && notes.length === 0 && (
            <p className="text-center text-gray-400">No notes yet</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notes;
